import React, { useEffect, useState } from 'react';
import { GoThumbsup, GoThumbsdown } from "react-icons/go"
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { get_posts_reaction_activity_by_user } from '../../../redux/Thunks/discussionsThunk';
import { get_debates_reaction_activity_by_user } from '../../../redux/Thunks/debatesThunk';


const RepliesSection = ({comment_eid, author_ID, username, comment_date, comment_text, img, commentHasBeenDeleted,
                           replyMedia, upvote_count, downvote_count, reactAction }) => {

    const { discussion_id } = useParams()
    const dispatch = useDispatch()
    const [reactionsPerComment, setReactionsPerComment] = useState()
    const [isClicked, setIsClicked] = useState([false, false])

    function getRxn(ID){
            dispatch(
            discussion_id ?
            get_posts_reaction_activity_by_user({
                user_id: author_ID,
                eid: ID
            })
            :
            get_debates_reaction_activity_by_user({
                user_id: author_ID,
                eid: ID
            })
        )
        .then(({ payload }) => {
            setReactionsPerComment(payload)
        });
    }

    const handleLikeAndDislikeColor = (mode) => {
        if(mode === "up"){
            setIsClicked([!isClicked[0], !isClicked[1]])
        }else{
            setIsClicked([!isClicked[0], !isClicked[1]])
        }
        
    }


    useEffect(() => {
        getRxn(comment_eid)

    //eslint-disable-next-line
    }, []);


    
    const frame = (pictures) => {
        if(pictures.length === 1){
            return "h-[200px] w-[200px] md:h-[300px] md:w-[300px]"
        }else if(pictures.length === 2){
            return "h-[150px] w-[150px] md:h-[200px] md:w-[200px]"
        }else if(pictures.length === 3){
            return "h-[150px] w-[150px] md:h-[200px] md:w-[200px]"
        }else if(pictures.length === 4){
            return "h-[100px] w-[100px] md:h-[200px] md:w-[200px]"
        }
        
    }                        

    return (
        <div className='flex flex-wrap ml-[8%] sm:ml-[14%]'>

<div className='flex px-3'>
            <div className='w-[35px] h-[35px] md:pt-4'>
            {commentHasBeenDeleted ?
            <div className='w-[35px] h-[35px] rounded-full bg-greenOnDarkMode' />
            :
            <img 
                src={img} 
                alt={`${username} profile`}
                className='w-full h-full] rounded-full'
                />
            }

            </div>


                <div className='lg:p-4 ml-3'>
                {commentHasBeenDeleted ?
                <p className='md:inline ml-0'>[deleted]</p>
                :
                 <div>
                 <p className='md:inline ml-0'>{username}</p>
                 <p className='inline m-1 my-2.5 sm:m-2.5 text-xs md:text-sm'>{comment_date}</p>
                </div>              
                }
                
                    <div className='my-3'>
                    {commentHasBeenDeleted ?
                    <p>[this comment has been deleted.]</p>
                    :
                    <>
                    <p className='my-3'>
                   {comment_text}
                    </p>
                    <div className='flex flex-wrap justify-center'>
                    {replyMedia?.map((item, idx) => {
                        return (<div key={idx} className={`${frame(replyMedia)} m-1`}>
                        {item.endsWith('mp4') ?  
                        (
                        <video 
                        className="w-full h-full object-cover"
                        controls>
                        <source src={item} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                        )
                        :
                        (
                        <Link to={item} target="_blank">
                            <img
                                src={item}
                                alt={`Media`}
                                className="w-full h-full object-cover"
                            />
                            </Link>
                        )
                        }
                        </div>)
                    })}
                    </div>
                    </>
                    }

                    </div>

                    <div className='flex w-full my-3 space-x-6'>
                    <p>{upvote_count}
                        <GoThumbsup
                            onClick={(e) => {
                                handleLikeAndDislikeColor("up")
                                reactAction(e)

                            }}
                            id="Thumbs_Up"
                            className={`
                            mx-1 text-2xl inline cursor-pointer
                             ${reactionsPerComment && 
                             (reactionsPerComment?.vote_type === "U" || isClicked[0]) && upvote_count > 0
                             ? "text-[#3C6E71]" : null}
                             `}
                        />
                    </p>



                    <p>{downvote_count}

                        <GoThumbsdown
                            onClick={(e) => {
                                handleLikeAndDislikeColor("down")
                                reactAction(e)
                            }}
                            id="Thumbs_Down"
                            className={`
                            mx-1 text-2xl inline cursor-pointer
                            ${reactionsPerComment && 
                               (reactionsPerComment?.vote_type === "D" || isClicked[1]) && downvote_count > 0
                             ? "text-red-400" : null}
                             `}
                        />
                    </p>
                    </div>
            </div>

            </div>

            </div>
    );
}

export default RepliesSection;
